// The admin allowlist, shared by the client (admin-only UI affordances) and the
// edge-server (the shop's fake-grant route re-checks it server-side). One list,
// imported from both sides, so it can't drift out of sync again.
var ADMIN_EMAILS = ["ommatte@gmail.com", "erik.odenman@gmail.com"];

// True for an admin's email. Case-insensitive; null/undefined-safe (logged out).
function isAdminEmail(email) {
    return !!email && ADMIN_EMAILS.indexOf(String(email).toLowerCase()) !== -1;
}

// A test account: an admin's address with a "+tag" (ommatte+new@gmail.com), signed
// in with the email link. It is a separate account whose mail still lands in the
// admin's inbox, and it may wipe itself back to a brand-new player (the
// edge-server's /api/test-account/reset), so the first-time experience can be
// played again and again.
function isTestAccountEmail(email) {
    var m = /^([^+@]+)\+[^@]+(@.+)$/.exec(String(email || "").toLowerCase());
    return !!m && isAdminEmail(m[1] + m[2]);
}

export { ADMIN_EMAILS, isAdminEmail, isTestAccountEmail };
